module.exports = __webpack_public_path__ + "d25b9a8404b6d7f7b3c2beda5b8e7171.svg";